module.exports = __webpack_public_path__ + "img/gnzs7.2a61c70a.png";